<template>
  <Row>
    <i-col span="24">
      <AffixHeader>
        <BreadcrumbItem slot="parent" to="/publishers">Publishers & Sources</BreadcrumbItem>
        <span slot="current">{{ isNew ? "New" : publisher.name }}</span>
        <span slot="title">{{ isNew ? "New" : "Edit" }} Publisher & Source</span>
        <span slot="sub-title">{{ fullname }}</span>
      </AffixHeader>

      <h1>{{ isNew ? "New" : "Edit" }} Sources & Publishers</h1>
      <br />

      <!-- <Alert type="error">
        <h4>All write operations are disabled on publishers</h4>
        <span slot="desc">
          Create, update and delete operations are disabled on publishers for the time until the end of the review process.
          View and document associations are still accessable.
        </span>
      </Alert>
      <br />-->

      <i-form ref="form" :model="publisher" :rules="rules" label-position="top">
        <!-- Name -->
        <i-form-item label="Name" prop="name">
          <i-input v-model="publisher.name"></i-input>
        </i-form-item>

        <!-- Type -->
        <i-form-item label="Type" prop="type">
          <!--
            <PublisherTyeSelect v-model="publisher.type"></PublisherTyeSelect>
          -->
          <i-select v-model="publisher.type" filterable>
            <i-option v-for="item in typeOptions" :value="item" :key="item">
              {{
              item
              }}
            </i-option>
          </i-select>
        </i-form-item>

        <i-form-item label="Country">
          <CountrySelect v-model="publisher.iso3" clearable filterable></CountrySelect>
        </i-form-item>

        <!-- Action Buttons -->
        <i-form-item class="action-buttons" v-if="$can('manage', 'publishers')">
          <i-button type="primary" @click="save">
            <FFIcon type="save" />
            {{ isNew ? "Create" : "Update" }}
          </i-button>
        </i-form-item>
      </i-form>
    </i-col>
    <LoadingSpinner :loading="loading"></LoadingSpinner>
  </Row>
</template>

<script>
import database from "@/database";
// import PublisherTyeSelect from "@/components/publisher_type_select.vue";
import CountrySelect from "@/components/country_select";

export default {
  components: {
    // PublisherTyeSelect,
    CountrySelect,
  },
  props: ["id"],

  data() {
    return {
      loading: false,
      publisher: {
        id: this.id,
        name: "",
        type: "",
        iso3: null,
      },
      rules: {
        name: { required: true, trigger: "blur", message: "Name is required" },
        type: { required: true, trigger: "blur", message: "Type is required" },
      },
      typeOptions: [
        "Civil Society",
        "Clusters and Consortias",
        "Community Leaders",
        "Government",
        "International NGOs",
        "International Organisations",
        "Local Authority",
        "Media",
        "National/Regional Disaster Authority",
        "Non-State Armed Group",
        "Private Sector",
        "Red Cross/Red Crescent Movement",
        "United Nations",
      ],
    };
  },

  mounted() {
    if (this.id !== null) {
      this.load();
    }
  },

  computed: {
    isNew() {
      return this.id === null;
    },
    fullname() {
      return this.publisher.name;
    },
  },

  methods: {
    load() {
      if (this.id !== null) {
        this.loading = true;
        database
          .load("publishers", this.id)
          .then(res => {
            this.publisher = res.data;
            this.loading = false;
          })
          .catch(err => {
            console.error(err);
            this.loading = false;
          });
      }
    },

    save() {
      // console.log(this.publisher);
      // return;
      if (!this.$can("manage", "publishers")) {
        this.$Message.error("User is not permitted");
        return;
      }
      const isNew = this.isNew;
      this.$refs["form"].validate(valid => {
        if (valid) {
          // Reset iso3
          if (this.publisher.iso3 === undefined) {
            this.publisher.iso3 = null;
          }
          // Store publisher
          database
            .save("publishers", this.publisher, {})
            .then(response => {
              this.publisher = response.data;
              this.loadingSuccess(
                isNew
                  ? "Source/Publisher has been created"
                  : "Source/Publisher has been updated"
              );
              this.$router.push(`/publishers/${this.publisher.id}`);
            })
            .catch(error => {
              console.error(error.response);
              let { details, message } = error.response.data;
              const desc = message || details;
              const title = isNew ? "Failed to create" : "Failed to update";
              this.$Notice.warning({ title, desc });
            });
        } else {
          this.$Message.error("Form errors!");
        }
      });
    },
  },
};
</script>

<style lang="css"></style>
